var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlusBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 127.6 127.6",
    style: {
      enableBackground: "new 0 0 127.6 127.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2680EB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.5,66.6h-17v17h-5.7v-17h-17v-5.7h17v-17h5.7v17h17V66.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,126.7c-34.7,0-62.9-28.2-62.9-62.9S29.1,0.8,63.8,0.8s62.9,28.2,62.9,62.9S98.5,126.7,63.8,126.7z  M63.8,4.8C31.3,4.8,4.8,31.3,4.8,63.8c0,32.5,26.4,58.9,58.9,58.9c32.5,0,58.9-26.4,58.9-58.9C122.7,31.3,96.3,4.8,63.8,4.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusBlue);
export default __webpack_public_path__ + "static/media/Circle-Plus_Blue.f7cc2567163178966897d75d8b7dcbb2.svg";
export { ForwardRef as ReactComponent };